import { useSelector } from "react-redux";
import { Information } from "../../../domain/information/Information";
import { InformationId } from "../../../domain/information/InformationId";
import { InformationTitle } from "../../../domain/information/InformationTitle";
import { InformationContent } from "../../../domain/information/InformationContent";
import { DateTime } from "../../../domain/fundamental/DateTime";
import { State } from "../../../state/store";

export const useInformation = (): Information | null => {
    const responseJson = useSelector((state: State) => state.information.information);

    return responseJson ? Information.from(
        InformationId.fromString(responseJson.id),
        InformationTitle.fromString(responseJson.title),
        InformationContent.fromString(responseJson.content),
        DateTime.fromString(responseJson.createdTime),
        responseJson.isRead
    ) : null;
};
